import { Component } from '@theme/component';

/** @extends {Component<{trigger:HTMLButtonElement,dialog:HTMLDialogElement,body:HTMLElement,closeButton:HTMLButtonElement}>} */
class VVFilterDrawer extends Component {
  requiredRefs = ['trigger','dialog','body','closeButton'];
  #controller;
  #media;
  #moved = [];
  #scrollOverflow;
  #closingTimer;
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.#media = matchMedia('(max-width:989px)');
    this.#media.addEventListener('change',this.#sync,{signal:this.#controller.signal});
    this.refs.dialog.addEventListener('cancel',event=>{event.preventDefault();this.close();},{signal:this.#controller.signal});
    this.refs.dialog.addEventListener('click',event=>{if(event.target===this.refs.dialog){const box=this.refs.dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right)this.close();}},{signal:this.#controller.signal});
    this.refs.dialog.addEventListener('close',this.#afterClose,{signal:this.#controller.signal});
    const root=this.closest('[data-vv-filter-root]');
    root?.querySelectorAll('.vv-shop-filters,.vv-shop-sidebar,.vv-collection-filter-shell').forEach(element=>{
      const placeholder=document.createComment('VV filter position');element.before(placeholder);this.#moved.push({element,placeholder});
    });
    this.#sync();
    this.dataset.ready='true';
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    clearTimeout(this.#closingTimer);
    if(this.refs.dialog?.open)this.refs.dialog.close();
    this.#afterClose();
    this.#restore();
    this.#moved.forEach(({placeholder})=>placeholder.remove());
    this.#moved=[];
  }
  #restore=()=>this.#moved.forEach(({element,placeholder})=>placeholder.after(element));
  #sync=()=>{
    if(this.#media.matches)this.#moved.forEach(({element})=>this.refs.body.append(element));
    else{this.refs.dialog.close();this.#restore();}
  };
  open() {
    clearTimeout(this.#closingTimer);
    this.refs.dialog.classList.remove('is-closing');
    if(this.refs.dialog.open)return;
    this.#scrollOverflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden';
    this.refs.dialog.showModal();
    this.refs.trigger.setAttribute('aria-expanded','true');
    this.refs.closeButton.focus();
  }
  close() {
    if(!this.refs.dialog.open)return;
    if(matchMedia('(prefers-reduced-motion:reduce)').matches){this.refs.dialog.close();return;}
    this.refs.dialog.classList.add('is-closing');
    clearTimeout(this.#closingTimer);
    this.#closingTimer=setTimeout(()=>this.refs.dialog.close(),300);
  }
  #afterClose=()=>{
    clearTimeout(this.#closingTimer);
    this.refs.dialog?.classList.remove('is-closing');
    this.refs.trigger?.setAttribute('aria-expanded','false');
    if(this.#scrollOverflow!==undefined){document.documentElement.style.overflow=this.#scrollOverflow;this.#scrollOverflow=undefined;}
  };
}
if(!customElements.get('vv-filter-drawer'))customElements.define('vv-filter-drawer',VVFilterDrawer);
